import { SortDirection } from '../../../enums/sortDirection'
import { ProductSortProperty } from '../enums/productSortProperty'
import { ProductsFilters } from '../types/productsFilters'

export const defaultProductsFilters: ProductsFilters = {
  page: 1,
  searchQuery: '',
  sortDirection: SortDirection.Asc,
  sortProperty: ProductSortProperty.Name,
}
